import React from 'react';
import propTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import './MonthNavigator.scss';

const MonthNagivator = ({ formattedStartDate, decrement, increment, currentType, start, end }) => {
  return (
    <div className="habit-month-navigator-row-container">
      <button
        key="a"
        onClick={() => decrement(currentType, start, end)}
        className="habit-month-increment-button-left"
      >
        <FontAwesome name="angle-left" />
      </button>
      <h1 className="habit-month-year">{formattedStartDate}</h1>
      <button
        key="b"
        onClick={() => increment(currentType, start, end)}
        className="habit-month-increment-button-right"
      >
        <FontAwesome name="angle-right" />
      </button>
    </div>
  );
};

MonthNagivator.propTypes = {
  formattedStartDate: propTypes.string,
  start: propTypes.object,
  end: propTypes.object,
  decrement: propTypes.func,
  increment: propTypes.func,
  currentType: propTypes.string,
};

export default MonthNagivator;
